import {
  Link as ChakraLink,
  Flex,
  Heading,
  HStack,
  IconButton,
  Image,
  Text,
} from '@chakra-ui/react'
import { Link } from '@tanstack/react-router'
import { Info as InfoIcon } from 'lucide-react'
import hivemqBee from '~/assets/hivemq-bee.svg'
import { ColorModeButton } from '~/color-mode'
import { AdminMenu, LinksMenu } from './TopBarMenus'
import { UserMenu } from './UserMenu'

export function TopBar() {
  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      h="100%"
      bg="bg.panel"
      borderBottomWidth="1px"
      borderColor="border"
      px={6}
    >
      <ChakraLink asChild cursor="pointer" _hover={{ textDecoration: 'none' }}>
        <Link to="/">
          <HStack gap={2.5}>
            <Image src={hivemqBee} alt="HiveMQ" boxSize="40px" />
            <HStack gap={1.5} align="baseline">
              <Heading size="md" lineHeight="1" letterSpacing="-0.5px">
                HiveMQ
              </Heading>
              <Text fontSize="md" fontWeight="medium" color="content.secondary" lineHeight="1">
                Stories
              </Text>
            </HStack>
          </HStack>
        </Link>
      </ChakraLink>

      <HStack gap={2}>
        {/* Deliberately NOT behind hasMinRole, unlike AdminMenu: the connection details
            are what every presenter needs first, so a plain user gets this too. asChild
            renders a single anchor styled as the button rather than a button nested in a
            link. Footprint matches the rest of the cluster - see ColorModeButton. */}
        <IconButton
          asChild
          // plain rather than ghost - see the note on ColorModeButton; ghost leaves a
          // filled square behind after the click.
          variant="plain"
          borderColor="transparent"
          _hover={{ bg: 'bg.subtle' }}
          _focus={{ bg: 'transparent' }}
          _active={{ bg: 'transparent' }}
          aria-label="Demo platform info"
          title="Demo platform info"
          boxSize="46px"
          borderRadius="2px"
        >
          <Link to="/demoinfo">
            <InfoIcon size={20} />
          </Link>
        </IconButton>
        <LinksMenu />
        <AdminMenu />
        <ColorModeButton />
        <UserMenu />
      </HStack>
    </Flex>
  )
}
